import { getCookie } from 'src/scripts/utils/cookies';
import { checkIfInVariation } from 'src/scripts/utils/optimizely';
import { SORT_BY_KEY } from '../../product-listing-page/components/sorting-utils';

export const experimentId = '18802302798';
export const variationName = 'Regular Pagination';
export const INFINITE_SCROLL_ENABLED = !checkIfInVariation({ variationName, experimentId });
export const ITEMS_PER_PAGE = 25;
export const MAX_FILTER_ITEMS_SHOWN = 12;

export const NON_FILTER_QUERY_PARAMS = [
  'q',
  '_ga',
  'addToWishlist',
  'addToWishlistSource',
  'auth_success',
  'is_modal',
  'auth_event',
  'origq',
  SORT_BY_KEY,
];

export const getBrowseApiHeaders = () => {
  const currentUrl = window.location.href;
  const refUrl = document.referrer;
  const BR_DEVICE_ID = getCookie('_br_uid_2');

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'BR-CurrentUrl': currentUrl || 'NO_CURRENT_URL',
    'BR-RefUrl': refUrl || 'NO_REFERRER_URL',
    'BR-DeviceId': BR_DEVICE_ID || 'NO_DEVICE_ID',
  };
};
